<template>
  <div
    class="tab-pane fade active show"
    id="willProcessToilet-content"
    role="tabpanel"
    aria-labelledby="willProcessToilet-tab"
  >
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">請選擇</option>
            <option
              v-for="(list, index) in toiletDeviceScenicArea"
              :key="index"
              :value="list.id"
            >
              {{ list.name }}
            </option>
          </select>
        </div>

        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">通報項目</label>
          <select
            class="form-control"
            id="SensorSN"
            name="SensorSN"
            v-model="selectType"
          >
          <!-- 目前公廁維運事件僅顯示氣味偵測異常與給皂機事件 -->
            <option selected="selected" value="-1">全部</option>
            <option v-for="(item, index) in iotEventTypeList" :value="item.enumType">
              {{ item.description}}
            </option>
    
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="startTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="endTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button
            type="button"
            class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
            @click="queryElk"
            :disabled="isWaitResult"
            @focus="updateMaxSelectTime"
          >
            <i class="fas fa-search"></i> 查詢
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm rounded-pill px-3 mx-1"
            @click="queryCSV"
            :disabled="isWaitResult"
            @focus="updateMaxSelectTime"
          >
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px">維運事件</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">
              <table id="willProcessToiletTable" :class="tableStyle">
                <thead class="table-dark">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">風景區</th>
                    <th scope="col">地點</th>
                    <th scope="col">通報時間</th>
                    <th scope="col">通報項目</th>
                    <th scope="col">通報內容</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, key) in dataTableList"
                    :key="key"
                    :class="tableCenterStyle"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ getScenicAreaName(item.scenicAreaId) }}</td>
                    <td>{{ item.publicPlaceName }}</td>
                    <td>{{ getTime(item.eventTime)}}</td>
                    <td>
                      {{ item.eventTypeName}}
                    </td>
                    <td>
                      {{item.infoPriority}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import exportCSV from "../../utils/exportCSV";

export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      startTime: moment().startOf("day").format(),
      endTime: moment().startOf("minute").format(),
      selectScenicAreaId: -1,
      selectType: "-1",
      // scenicAreaHandsanitizerList: [],
      // scenicAreaPeculiarSmellList: [],
      scenicAreaIotEventList: [],
      iotEventTypeList: [],

      dataTableList: [],
      isWaitResult: false,
      maxSelectTime:Utils.getLastestTime(), 
    };
  },
  computed: {
    // ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),

    ...mapState("iotEvent", { iotEventType: "allIotEventTypes" }),

    // maxSelectTime() {
    //   return moment().startOf("m").toISOString();
    // },

    toiletDeviceScenicArea() {
      //僅出現有公廁設備的風景區
      return this.scenicAreaList.filter(
        (s) =>
          s.additionInfo &
          CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PROVIDER_TOILET_DEVICE
      );
    },
  },
  watch: {
    async selectScenicAreaId() {
      if (this.selectScenicAreaId !== -1) {
        await this.$store.dispatch("scenicArea/getDeviceByScenicAreaId", {
          id: this.selectScenicAreaId,
        });
      }
    },

  
  },
  methods: {
    async queryCSV() {
      const allDatas = await this.searchElk();
      if (Utils.isEmptyObject(allDatas)) {
        return;
      }

      const csvContent = [
        ["風景區", "地點", "通報時間", "通報項目", "通報內容"],
      ];

      allDatas.forEach((item) => {
        const row = [];
        row.push(this.getScenicAreaName(item.scenicAreaId));
        row.push(item.publicPlaceName);
        row.push(this.getTime(item.eventTime));
        row.push(item.eventTypeName);
        row.push(item.infoPriority);

        csvContent.push(row);
      });

      const fileName = `CSV_${moment(this.startTime).format(
        "YYYY/MM/DD HH:mm"
      )}_公廁狀況.csv`;
      exportCSV.genCSVFile(csvContent, fileName);
    },

    async queryElk() {
      const allDatas = await this.searchElk();
      this.dataTableList = allDatas;
      this.updateTable();
    },

    async searchElk() {
      if (
        Utils.isEmptyObject(this.startTime) ||
        Utils.isEmptyObject(this.endTime)
      ) {
        alert("請選擇起訖時間");
        return;
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert("結束時間不可以小於開始時間");
        return;
      }

      if (this.selectScenicAreaId === -1) {
        let allDatas = [];
        alert("請選擇風景區");
        return;
      }
      
      
      const st = moment(this.startTime).valueOf();
      const et = moment(this.endTime).valueOf();
      // const st = "2024-01-25T00:00:00+08:00";
      // const et = "2024-01-25T23:59:59+08:00";
      
      const condition = {
        startTime: st,
        endTime: et,
        scenicAreaId: this.selectScenicAreaId,
        type: [this.selectType],
      };
      if(this.selectType === "-1"){
        //若選擇全部，則搜尋所有的公廁維運事件種類
        condition.type = this.iotEventTypeList.map((item) => item.enumType);
      }
   

      await this.$store.dispatch("iotEvent/getIotEvent", condition);
      const result = this.$store.getters["iotEvent/getIotEventData"];
  
      let allDatas = [];
      allDatas = result;
     
      return allDatas;
    },

    getScenicAreaName(item){
     
      return Utils.getSingleScenicAreaNamebyId(item);
    },
    
    getIotType(){
      this.iotEventTypeList = CONST.EAST_COAST_DEVICE_IOT_TYPE;
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item)) {
        return "-";
      }

      return moment(item).format("YYYY/MM/DD HH:mm");
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    initTable: function () {
      this.table = $("#willProcessToiletTable").DataTable({
        aoColumns: [
          ...new Array($("#willProcessToiletTable th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: "/json/dataTableZHTW.json",
        },
        pageLength: 25,
      });
    },
    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
  },
  mounted() {
    this.updateTable();
    this.getIotType();


  },
};
</script>
<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

select:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

tbody>tr>td, tr > th {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

/* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
}

/* table不超過div */
</style>
